import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DiaryNoteDetailsComponent } from '../details/diary-note-details.component';
import { DiaryNoteService } from '@features/diary-notes/services/diary-note.service';
import { DiaryNote } from '@features/diary-notes/model/diary-note';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-diary-note-new',
  templateUrl: '../details/diary-note-details.component.html',
  styleUrls: ['../details/diary-note-details.component.scss']
})
export class DiaryNoteNewComponent
  extends DiaryNoteDetailsComponent
  implements OnInit
{
  constructor(diaryNoteService: DiaryNoteService, protected fb: FormBuilder) {
    super(diaryNoteService, fb);
  }

  get saveLabel(): string {
    return 'Add';
  }

  get title(): string {
    return 'Add Diary Note';
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  content(): Observable<DiaryNote.Model> {
    return of({} as DiaryNote.Model);
  }

  get isNewDiaryNote(): boolean {
    return true;
  }
}
